import {
  FormControl, InputBase, MenuItem, Select,
} from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';
import { Project } from '../../types/items';
import { selectAllowChangeProjectStatus, selectProject } from '../../store/modules/projects/selectors';
import useStyles from './styles';
import { StatusKeys } from './types';
import { saveProjectRequest } from '../../store/modules/projects/actions';
import StatusSelectOption from './StatusSelectOption';
import ProjectStatusChangeConfirmModal
  from '../../views/projects/actions/ProjectStatusGroupActions/ProjectStatusChangeConfirmModal';
import useProjectStatuses from '../../hooks/useProjectStatuses';

const StatusSelect = () => {
  const { data: currentProject, loading: projectLoading } = useSelector(selectProject);
  const projectStatus = currentProject?.status_id;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [projectStatusId, setProjectStatusId] = useState(0);
  const statuses = useProjectStatuses();
  const allowChangeProjectStatus = useSelector(selectAllowChangeProjectStatus);

  const updateProjectHandler = useCallback((statusId: number = projectStatusId) => {
    const project = { ...currentProject } as Project;
    project.status_id = statusId;
    dispatch(saveProjectRequest(project));
  }, [dispatch, currentProject, projectStatusId]);

  const onChangeSelectHandler = useCallback((e) => {
    if (e.target.value) {
      setProjectStatusId(e.target.value);
      if (!allowChangeProjectStatus) {
        setShowModal(true);
        return;
      }
      updateProjectHandler(e.target.value);
    }
  }, [allowChangeProjectStatus, updateProjectHandler]);

  return (
    <>
      <FormControl className={classes.selectWrapper}>
        <InputLabel
          htmlFor="status-select"
          className={classes.label}
        >
          Status
        </InputLabel>
        {(statuses && statuses.length)
          ? (
            <Select
              id="status-select"
              value={projectStatus}
              onChange={onChangeSelectHandler}
              MenuProps={{ style: { zIndex: 2147483100 } }}
              input={<InputBase />}
              disabled={projectLoading}
              className={classes.select}
              inputProps={{
                className: classes.selectInput,
              }}
            >
              {
                statuses.map((status) => (
                  <MenuItem key={status.id} value={status.id}>
                    <StatusSelectOption title={status.title} statusKey={status.id as StatusKeys} />
                  </MenuItem>
                ))
              }
            </Select>
          )
          : null}
      </FormControl>
      <ProjectStatusChangeConfirmModal
        open={showModal}
        cancelCallback={updateProjectHandler}
        approveCallback={() => setShowModal(false)}
      />
    </>
  );
};

export default StatusSelect;
